import * as React from "react";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { MediaBlock } from "./mediaBlock";

export type VideoBlockProps = {
    caption?: string
    url: string
    isUpload: boolean
    embed_url: string
    contentWidth: 'content-width' | 'full'
    hasIntro: boolean
    hasTitle: boolean
    intro: string
    title: string
}

export type MediaBlockStyle = Partial<{
    block_classname: string
    inview_classname: string
    inner_classname: string
    header_classname: string,
    title_classname: string,
    intro_classname: string,
    content_classname: string
    figure_contentwidth_classname: string
    figure_fullwidth_classname: string
    figure_image_classname: string
    figure_video_classname: string
    media_classname: string
    image_classname: string
    placeholder_classname: string
    video_classname: string
    figcaption_classname: string
    caption_classname: string
    source_classname: string
    cookies_classname: string
    cookies_inner_classname: string
    cookies_text_classname: string
    cookies_clickable_classname: string
}>


export function VideoBlock<CustomBlockData, extra_images>(
    props: VideoBlockProps,
    options?: { style?: MediaBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
    return (cmsState: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => {
        const { hasTitle, hasIntro, title, intro, contentWidth, url, caption, embed_url, isUpload } = props

        if (!isUpload) {
            return MediaBlock<CustomBlockData, extra_images>({
                type: 'video',
                useCookieBar: true,
                video: {
                    url: embed_url,
                    allowFullScreen: true,
                    frameBorder: '0',
                    id: embed_url,
                    hasIntro: hasIntro,
                    hasTitle: hasTitle,
                    intro: intro,
                    title: title,
                    contentWidth: contentWidth,
                },
                caption: caption
            }, options)(cmsState)
        }

        return mk_widget({
            run: setState => {
                return (
                  <section className={`block block--media block--video${contentWidth === 'full' ? ' block--full-width' : ''}`}>
                    <div className={`block__inner container container--${contentWidth === 'full' ? 'm' : 's'} gutter--m spacing--m`}>
                      <div className="block__content">
                        <figure className="block__media">
                          {(props.hasTitle || props.hasIntro) && (
                            <div className="block__message">
                              {hasTitle && (
                                <h2 className="block__title typo--l ff--primary first-item">{props.title}</h2>
                              )}
                              {hasIntro && (
                                <div
                                  className="block__intro second-item"
                                  dangerouslySetInnerHTML={{ __html: props.intro }}
                                />
                              )}
                            </div>
                          )}
                          {url && (
                            <div className="block__visual">
                              <video controls>
                                <source src={url} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          )}
                          {caption && <figcaption className="block__caption typo--ms">{caption}</figcaption>}
                        </figure>
                      </div>
                    </div>
                  </section>
                )
            }
        })
    }
}
